import { Route, Routes } from "react-router-dom";

import EntityListScreen from "screens/App/CRM/EntityListOption/EntityListOptionScreen";
import EntityListDetailScreen from "screens/App/CRM/EntityListOption/EntityListOptionDetailScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const EntityListRouter = () => {
  return (
    <Routes>
      <Route index element={<EntityListScreen />} />
      <Route path="detail/:id" element={<EntityListDetailScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default EntityListRouter;
